export default __webpack_public_path__ + "static/media/LikeImage.e73e447e.png";